import mapActions from "actions/map";
import modalActions from "actions/modal";
import { FormTemplate } from "components/modal/templates";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import React from "react";
import { connect } from "react-redux";
import { apply } from "sources/books/itemChangePoints";

class CreateTruckingBidModal extends FormTemplate {
    sendRequest = (stateData) => apply(stateData).then(this.props.successCallback);

    renderBodyInner = () => {
        const { config } = this.props;
        return (
            <>
                {this.renderField(config.name)}
                <div className="row form-group field-wrap--value">
                    <label className="col-sm-4 col-md-3 col-form-label col-form-label-sm text-md-right text-sm-left">
                        Адрес
                    </label>
                    <div className="col-sm-8 col-md-9 col-form-label col-form-label-sm">
                        {this.state.geozone.address}
                    </div>
                </div>
            </>
        );
    };
}

const config = {
    name: {
        // field
        label: "Название",
        inputProps: { name: "name" },
        validators: [requiredField],
        required: true,
    },
    geozone: {
        // field
        label: "Адрес",
        inputProps: { name: "geozone" },
        validators: [requiredField],
        required: true,
    },
};

const initialState = getInitialStateFromConfig(config);

const ConfiguredModal = (props) => (
    <CreateTruckingBidModal {...props} config={config} initialState={{ ...initialState, geozone: props.mapObject }} />
);

const customDispatch = (dispatch) => {
    return {
        addModal: (params) => dispatch(modalActions.add(params)),
        switchMap: (params) => dispatch(mapActions.switchMap(params)),
    };
};

const mapState = (_state) => ({});
const customConnect = (Component) => connect(mapState, customDispatch)(Component);

export default customConnect(ConfiguredModal);
